export function getLevelNumber(level) {
	return parseInt(level.substring(2));
}
